(function () {
  function initMarquee(el) {
    if (!el || el.dataset.thyredMarqueeReady === '1') return;
    el.dataset.thyredMarqueeReady = '1';
    var state = { hover: false, dragging: false, startX: 0, startScroll: 0, running: false };
    var speed = 35; // px/s
    var last = performance.now();
    function tick(now) {
      var dt = (now - last) / 1000;
      last = now;
      var half = el.scrollWidth / 2;
      if (state.running && !state.hover && !state.dragging) {
        el.scrollLeft += speed * dt;
      }
      if (el.scrollLeft >= half) el.scrollLeft -= half;
      else if (el.scrollLeft < 0) el.scrollLeft += half;
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    // Hold still until the section scrolls into view; then show the first
    // verified-purchase card centered, pause so it registers, then drift.
    function centerVerified() {
      var target = el.querySelector('.rcard:not([aria-hidden]) .rtag--verified');
      var card = target ? target.closest('.rcard') : null;
      if (card) {
        var pos = card.offsetLeft + card.offsetWidth / 2 - el.clientWidth / 2;
        var half = el.scrollWidth / 2;
        if (half > 0) pos = ((pos % half) + half) % half;
        el.scrollLeft = pos;
      }
    }
    function start() {
      centerVerified();
      setTimeout(function () { state.running = true; }, 2500);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) {
          io.disconnect();
          start();
        }
      }, { threshold: 0.35 });
      io.observe(el);
    } else {
      start();
    }

    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    if (canHover) {
      el.addEventListener('mouseenter', function () { state.hover = true; });
      el.addEventListener('mouseleave', function () { state.hover = false; });
    }

    el.addEventListener('pointerdown', function (e) {
      state.dragging = true;
      state.startX = e.clientX;
      state.startScroll = el.scrollLeft;
      el.classList.add('is-dragging');
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (!state.dragging) return;
      var dx = e.clientX - state.startX;
      el.scrollLeft = state.startScroll - dx;
    });
    function endDrag(e) {
      state.dragging = false;
      el.classList.remove('is-dragging');
      try { el.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
  }

  function boot() {
    document.querySelectorAll('[data-thyred-beta-marquee]').forEach(initMarquee);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
